import styled from 'styled-components';

export const StrengthWrapper = styled.div`
  margin-top: 0.5rem;
`;

export const StrengthBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  overflow: hidden;
`;

export const StrengthBar = styled.div`
  height: 100%;
  width: ${({ strength }) => {
    switch (strength) {
      case "faible":
        return "25%";
      case "moyen":
        return "50%";
      case "fort":
        return "75%";
      case "robuste":
        return "100%";
      default:
        return "0%";
    }
  }};
  background-color: ${({ strength }) => {
    switch (strength) {
      case "faible":
        return "yellow";
      case "moyen":
        return "orange";
      case "fort":
        return "blue";
      case "robuste":
        return "green";
      default:
        return "transparent";
    }
  }};
  transition: width 0.3s ease;
`;

export const StrengthLabel = styled.div`
  margin-top: 0.25rem;
  font-size: 0.9rem;
  font-weight: bold;
  color: ${({ strength }) => {
    switch (strength) {
      case "faible":
        return "yellow";
      case "moyen":
        return "orange";
      case "fort":
        return "blue";
      case "robuste":
        return "green";
      default:
        return "inherit";
    }
  }};
  text-transform: capitalize;
`;